import { Routes } from '@angular/router';
import { Foc } from './../foc/components/main/foc.component';
// import { AuthenticatedRoutesGuard } from './services/authenticated-routes-guard.service';
// import { LaunchPage } from 'modules/desktop/components/shared/launch-page/launch-page.component';
// import { LaunchPageResolver } from 'modules/desktop/services/launch-page-resolver.service';

export const ROUTES: Routes = [
  
    {
      path: '', component: Foc
    },
    // {
    //   path: 'launch-page', component: LaunchPage, canActivate:[AuthenticatedRoutesGuard], resolve: { resolveData: LaunchPageResolver }

    // },
    {
      path: '**', redirectTo: '', pathMatch: 'full'
    }
      
];
